import { render, staticRenderFns } from "./BusinessPhoto.vue?vue&type=template&id=d918ef24&scoped=true&"
import script from "./BusinessPhoto.vue?vue&type=script&lang=js&"
export * from "./BusinessPhoto.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPhoto.vue?vue&type=style&index=0&id=d918ef24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d918ef24",
  null
  
)

export default component.exports